module.exports = __webpack_public_path__ + "static/media/ValueFirstLogo.fa00ca72.png";